import { Typography } from "@material-ui/core"


interface PropsTitleChart {
    text: string
}

export const TitleChart = (props: PropsTitleChart) => {
    return (
        <Typography className="title-chart-dashboard">{props.text}</Typography>
    )
}